// The public pages (about / install / faq / privacy / terms / refunds / accessibility / delete-account) are the only part of the app that
// carries the language in the URL: Google needs one address per language to
// index four of them. Hebrew is the default and keeps the bare path, so every
// link that already exists stays valid.
export const PUBLIC_LANGS = ['he', 'en', 'ar', 'ru']
export const DEFAULT_PUBLIC_LANG = 'he'
export const PUBLIC_PATHS = ['/', '/about', '/install', '/pricing', '/faq', '/privacy', '/terms', '/refunds', '/how-to-cancel', '/delete-account', '/referral-terms', '/accessibility']

export const RTL_PUBLIC_LANGS = ['he', 'ar']
export const SITE_URL = 'https://master-splitter.com'

export const APP_STORE_URL = 'https://apps.apple.com/il/app/master-splitter/id6805147272'
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.mastersplitter.app'

export function isRtl(lang) {
  return RTL_PUBLIC_LANGS.includes(lang)
}

// /about and / show the same page: / is the address Google indexes, /about is
// the one that keeps working for a signed-in visitor, whose / is the app.
export function canonicalPath(path) {
  return path === '/about' ? '/' : path
}

export function publicPath(lang, path) {
  if (!lang || lang === DEFAULT_PUBLIC_LANG) return path
  // '/' is the home page, so '/en' - not '/en/'.
  return path === '/' ? `/${lang}` : `/${lang}${path}`
}

// '/en/terms' -> { lang: 'en', path: '/terms' }; '/terms' -> { lang: 'he', path: '/terms' }
export function splitPublicPath(pathname) {
  const [, first, ...rest] = pathname.split('/')
  if (PUBLIC_LANGS.includes(first) && first !== DEFAULT_PUBLIC_LANG) {
    return { lang: first, path: rest.length ? `/${rest.join('/')}` : '/' }
  }
  return { lang: DEFAULT_PUBLIC_LANG, path: pathname }
}

// Resolves whatever i18n reports ('en-GB', 'he') to a language the public
// pages actually ship.
export function publicLang(lng) {
  const tag = String(lng || '')
  return PUBLIC_LANGS.find((code) => tag.startsWith(code)) || DEFAULT_PUBLIC_LANG
}
